import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export function SEO({ title, description, image, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Emini Reinigung` : "Emini Reinigung – Sauber. Bis ins Detail.";
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    if (image) setMeta("property", "og:image", image);
    const url = `${window.location.origin}${path ?? window.location.pathname}`;
    setMeta("property", "og:url", url);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, image, path]);
  return null;
}
